<template>
  <div>
    <div class="page-title">Email Log</div>
    <div class="page-box">
      <div class="page-box-title">
        <div>
          <exportExcel buttonTitle="Export" :tableLabels="tableLabels" :labels="multipleSelection"></exportExcel>
        </div>
      </div>
      <div class="search-box">
        <el-collapse-transition>
          <el-form
            label-width="180px"
            v-show="show3"
            ref="ruleForm"
            :model="formLabelAlign"
          >
            <el-form-item label="SendAt">
              <el-date-picker
                v-model="formLabelAlign.sendAt"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="Status">
              <el-select v-model="formLabelAlign.status" placeholder="">
                <el-option
                  v-for="(item, index) in status"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="warning" @click="onSearch"
                >Search</el-button
              >
              <el-button icon="el-icon-refresh-left" @click="onReset"
                >Reset</el-button
              >
            </el-form-item>
          </el-form>
        </el-collapse-transition>
      </div>
      <el-table
        :data="application"
        @selection-change="handleSelectionChange"
        style="width: 100%;"
      >
        <el-table-column type="selection" width="55"> </el-table-column>

        <el-table-column prop="sendAt" label="Send at">
          <template slot-scope="scope">
            {{ scope.row.sendAt | formatDateEn }}</template
          >
        </el-table-column>
        <el-table-column prop="to" label="To"></el-table-column>
        <el-table-column prop="from" label="From"></el-table-column>
        <el-table-column prop="status" label="Send Status">
          <template slot-scope="scope">
            <span :class="[statusClass(scope.row.status) ]">{{
              scope.row.status | status
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="subject" label="Subject"></el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :pageSizes="[20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :page.sync="formLabelAlign._page"
        :limit.sync="formLabelAlign._limit"
        @pagination="getEmailLogs"
      />

    </div>
  </div>
</template>

<script>
import exportExcel from "@/components/exportExcel";
import Pagination from "@/components/Pagination";
import {getEmailLogs} from '@/api/admin/setting'
export default {
  components: { Pagination,exportExcel },
  filters:{
    status(v){
      return v===0?'Pendding':v===1?'Delivered':v===2?'Failed or Rejected':''
    },
  },
  data() {
    return {
      applicationList: [],
      tableLabels:[
        {
        label:'sendAt',
        prop:'sendAt'
        },
        {
        label:'to',
        prop:'to'
        },
        {
        label:'from',
        prop:'from'
        },
        {
        label:'status',
        prop:'status'
        },
        {
        label:'subject',
        prop:'subject'
        },
      ],
      status:[
        {
          label:'Pendding',
          value:0
        },
        {
          label:'Delived',
          value:1
        },
        {
          label:'Failed or Rejected',
          value:2
        }
      ],
      applicationFormIds: [],
      centerDeleteDialogVisible: false,
      total: 0,
      show3: true,
      application: [],
      multipleSelection: [],
      centerDialogVisible: false,
      formLabelAlign: {
        sendAt: null,
        status: null,
        _page: 1,
        _limit: 20,
      },
    };
  },
  created() {
    this.getEmailLogs();
  },
  methods: {
    statusClass(v){
      switch (v) {
        case 1:
          return 'delived';
        case 2:
          return 'failed';
        default:
          return '';
      }
    },
    closeCenter() {
      this.centerDialogVisible = false;
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if(key === '_page'){
          this.formLabelAlign[key] = 1;
        }
        if(key === '_limit'){
          this.formLabelAlign[key] = 10;
        }
      })
      this.getEmailLogs();
    },
    onCancel() {
      this.centerDeleteDialogVisible = false;
    },
    closeDelete() {
      this.centerDeleteDialogVisible = false;
    },
    onSearch() {
      this.getEmailLogs();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    close(v) {
      this.centerDialogVisible = v;
    },

    onConfirm() {
      this.batchDeleteApplicationForms();
    },

    getEmailLogs() {
      let from = {
        sendAt: this.formLabelAlign.sendAt,
        status: this.formLabelAlign.status,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getEmailLogs(from).then((v) => {
        this.application = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
}
.page-box-title {
  display: flex;
  border-bottom: 1px solid #707070;
  justify-content: flex-end;
  padding: 0 47px;
  padding-top: 46px;
  padding-bottom: 27px;
}
.search-box {
  padding-top: 50px;
  padding-bottom: 40px;
  padding-left: 50px;
  padding-right: 50px;
}
.el-button--primary {
  width: auto;
  background-color: #060c60;
  border-color: #060c60;
  font-size: 20px;
  font-weight: bold;
}
.dialog-text {
  font-size: 36px;
  color: #272727;
  text-align: center;
}
.delived{
  color: #2eac00;
}
.failed{
  color: #ff7272;
}
</style>